module.exports = __webpack_public_path__ + "static/img/item3@2x.ba3fa3bf.png";